import type { UserSettingsPatch } from "@chessla/shared";
import { ApiRequestError } from "@/shared/api/client";

export const saveUserSettingsChange = async (
  update: (settings: UserSettingsPatch) => Promise<void>,
  settings: UserSettingsPatch,
  showNotification: (message: string, tone: "error") => void,
): Promise<void> => {
  try {
    await update(settings);
  } catch (error) {
    showNotification(error instanceof ApiRequestError ? error.message : "Unable to save your settings", "error");
  }
};
